import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { textFieldStyles } from 'quoting/new-quote/helpers';
import { useCallback } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { defaultFeedback, feedbackEmail } from 'shared/constants/quotes';
import { useQuoteListState } from 'shared/contexts/quotes-summary-context';
import { FormTextField } from 'shared/controls';
import { useSendSupportEmail } from 'shared/mutations/send-support-email';
import { useAuthState } from 'shared/stores';
import { FeedbackForm } from 'shared/types/quotes';

export function FeedbackDialog() {
  const authState = useAuthState();
  const user = authState.user.value?.displayName || '';
  const userEmail = authState.user.value?.email ?? '';
  const { dialogOpen, toggleDialog } = useQuoteListState();
  const supportEmailMutation = useSendSupportEmail();

  const methods = useForm<FeedbackForm>({
    defaultValues: defaultFeedback,
  });

  const { handleSubmit, reset } = methods;

  const onClose = useCallback(() => {
    reset();
    toggleDialog();
  }, [reset, toggleDialog]);

  const onSubmit = async (data: FeedbackForm) => {
    await supportEmailMutation.mutateAsync({
      comment: data.feedback,
      user: data.name,
      userEmail: data.email,
      emailSentTo: feedbackEmail,
    });

    toggleDialog();
  };

  return (
    <Dialog open={dialogOpen} onClose={onClose} fullWidth={true} aria-labelledby='feedback-dialog'>
      <DialogTitle id='feedback-dialog-title'>Submit Feedback</DialogTitle>
      <DialogContent>
        <FormProvider {...methods}>
          <form id='feedback-form' onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ marginTop: 1 }}>
              <FormTextField sx={textFieldStyles} name='name' label='Name' defaultValue={user} fullWidth />
            </Box>
            <Box sx={{ marginTop: 1 }}>
              <FormTextField
                sx={textFieldStyles}
                name='email'
                label='Email address'
                defaultValue={userEmail}
                fullWidth
              />
            </Box>
            <Box sx={{ marginTop: 1 }}>
              <FormTextField sx={textFieldStyles} name='feedback' label='Comments' multiline />
            </Box>
          </form>
        </FormProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='primary'>
          Cancel
        </Button>
        <Button type='submit' form='feedback-form' color='primary'>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
